import { configureStore } from "@reduxjs/toolkit";
import ticketreducer from "./TicketSlice";
import loginSlice from "./userSlice";
import UserSlicer from "./userTicketSlice";

const Store = configureStore({
  reducer: {
    tickets: ticketreducer,
    login: loginSlice,
    userinfo: UserSlicer,
  },
});

export default Store;
